<template>
    <div>
        <div class="card">
            <div class="card-header">项目成果物</div>
            <div class="card-body" v-if="projectAchievementData.length===0">
                <div class="alert alert-warning mb-0">没有定义的项目成果物</div>
            </div>
            <table v-else class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 30%">名称</th>
                    <th class="text-center align-middle" style="width: 60%">成果物描述</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in projectAchievementData" :key="item.achievementId">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-left align-middle">{{item.achievementName}}</td>
                    <td class="text-left align-middle">{{item.achievementDescription}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";

export default {
    name: "ProjectAchievementView",
    props: {
        projectId: {type: String, required: true},
    },
    data: function () {
        return {
            projectAchievementData: [],
        };
    },
    mounted() {
        this.getProjectAchievementData();
    },
    methods: {
        getProjectAchievementData() {
            projectApi.project.achievement.getProjectAchievementData(this.projectId).then(res => {
                this.projectAchievementData = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>